<template>
  <div class="column-title">
    <h2>{{ data.name }}</h2>
    <div class="title-left-control">
      <div class="control" v-for="(elx, idx) in data.leftControl" :key="idx">
        <template v-if="elx.component === 'Tabs'">
          <Tabs
            @on-click="
              (val) => {
                handleTabs(elx, val)
              }
            "
          >
            <Tab-pane label="课班"></Tab-pane>
            <Tab-pane label="托管"></Tab-pane>
          </Tabs>
        </template>
        <template v-if="elx.component === 'DatePicker'">
          <Date-picker
            :clearable="false"
            :options="dateOptions"
            :value="dateValue"
            @on-change="
              (val) => {
                handleDate(elx, val)
              }
            "
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom"
            placeholder="选择日期"
            style="width: 220px"
          ></Date-picker>
        </template>
        <template v-if="elx.component === 'DateSingle'">
          <DatePicker
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            :clearable="false"
            :value="dateValueSign"
            @on-change="
              (val) => {
                handleDate(elx, val)
              }
            "
            style="width: 200px"
          ></DatePicker>
        </template>
      </div>
    </div>
    <div class="title-right-control">
      <slot name="moreSlot"></slot>
    </div>
  </div>
</template>

<script>
import { DateShortcuts } from "./config";
import { getWeekDate } from "@utils/utils";
export default {
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dateValue: [],
      dateOptions: {
        shortcuts: [...DateShortcuts]
      },
      dateValueSign: ""
    };
  },
  created() {
    const { startDate, endDate } = getWeekDate();
    this.dateValue = [startDate, endDate];
    this.dateValueSign = new Date().Format("yyyy-MM-dd");
  },
  methods: {
    handleTabs(row, val) {
      this.$eventHub.$emit(`on${row.field}`, val + 1);
    },
    handleDate(row, val) {
      this.$eventHub.$emit(`on${row.field}`, val);
    }
  }
};
</script>

<style lang="scss" scoped>
.column-title {
  display: flex;
  align-items: center;
  // line-height: 45px;
  h2 {
    position: relative;
    padding-left: 10px;
    font-size: 18px;
    font-weight: 600;
    color: #444444;
    &::before {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 20px;
      background: #488ffa;
    }
  }
  .title-left-control {
    display: flex;
    align-items: center;
    margin-left: 20px;
    /deep/.ivu-tabs-tab {
      padding: 8px 9px;
    }
    /deep/.ivu-tabs-bar {
      border-bottom: 0;
      margin-bottom: 9px;
    }
    /deep/.ivu-tabs-nav .ivu-tabs-tab:hover {
      color: #488ffa !important;
    }
    .control:nth-child(2) {
      position: absolute;
      right: 30px;
      top: 36px;
    }
  }
  .title-right-control {
    position: absolute;
    right: 30px;
    .more {
      display: flex;
      align-items: center;
      cursor: pointer;
      &-text {
        font-size: 16px;
        font-weight: 600;
        color: #488ffa;
        // margin-right: 8px;
      }
      /deep/.ivu-icon {
        font-size: 18px;
        font-weight: 600;
        color: #488ffa;
      }
      label {
        min-width: 78px;
      }
      /deep/.ivu-select {
        width: 200px;
      }
    }
  }
  width: 100%;
  margin-bottom: 20px;
}
</style>
